<template>
  <HeadClone @back="back" @next="next" v-model:next="nextArr">{{ activeList[active].title }}</HeadClone>
  <!-- <myhead @next="next">{{ activeList[active].title }}</myhead> -->
  <div class="fixed l r t mt44 pad5 BGwhite" style="z-index:5">
    <div class="ml10 flex mr10 BGf0 radius30 nowrap">
      <img src="@/assets/img/icon-search.png" class="width22px pad2 ml10 mr10 pointer" @click="getKeyList" alt="">
      <input type="text" class="flex1 size14" style="height:34px;background:none;" placeholder="请输入搜索关键词" v-model.trim="keyword"
        v-on:keyup.enter="getKeyList" key="1" />
      <img src="@/assets/img/icon32.png" v-if="keyword" @click="keyword='';getKeyList();"
        class="width22px pad4 BGwhite pointer opacity7 radius20 ml10 mr6" alt="">
    </div>
  </div>
  <div class="mt50">
    <ImgBox :imgStatus="!keyword" :title="activeList[active].title" :banner='banner'></ImgBox>
  </div>

  <van-empty description="暂无数据" v-if="list.length==0" />
  <div ref="wrapper" class="scroll" v-else  @scroll.passive="isScrollBottom">
    <div class="pad15">
      <!-- <ImgBox :imgStatus="!keyword" :title="activeList[active].title" :banner='banner'></ImgBox> -->
      <!-- <img v-if="!keyword" :src="banner" class="banner"> -->
      <div v-for="item,index in list" :key="index" class="myflex BGwhite mb15 radius8 pad14"
        @click="$router.push({path:'/recruit/detail',query:{id:item.id,cate_id:item.cate_id}})">
        <img :src="item.thumb" class="thumb" :onerror="imgError">
        <div class="textwidth">
          <div class="flex between mb10">
            <div class="width60 flex ">
              <span class="maxwidth ellipsis size16 weight">{{item.name}}</span>
              <!-- <span class="already" v-if="item.is_deliver == 1">已投</span> -->
            </div>
            <div class="Con">{{item.salary || '-'}}</div>
          </div>
          <div class="flex between mt10 size14">
            <div>岗位发布人：<span class="C999">{{item.publish_name||'-'}}</span></div>
              <span class="already" v-if="item.is_deliver == 1">已投</span>
              <span class="already BGon"  v-else>投递</span>
            
          </div>
          <p class="ellipsis">简介: <span class="C999">{{item.description}}</span></p>
          
        </div>
      </div>
    </div>
  </div>

  <van-tabbar v-if="$store.state.nokey">
    <van-tabbar-item v-show="active==0" @click="onActiveChange(item.value,true)" v-for="item,index in activeList.slice(1,3)"
      :key="index" class="Con">
      <img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}</van-tabbar-item>
    <van-tabbar-item v-show="active==1" @click="onActiveChange(item.value,true)" v-for="item,index in [activeList[2],activeList[0]]"
      :key="index" class="Con">      <img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}
</van-tabbar-item>
    <van-tabbar-item  v-show="active==2" @click="onActiveChange(item.value,true)" v-for="item,index in activeList.slice(0,2)"
      :key="index" class="Con">      <img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}
</van-tabbar-item>
  </van-tabbar>
  <div v-if="$store.state.nokey" @click="$router.push({path:'/feedback',query:{ column_type:4,cate_id:active+1 }})" class="fixed l b mb80 Cfff"
    style="border-radius:0 20px 20px 0;padding:10px 18px;background:rgba(8,109,143,.45)">意见反馈</div>

</template>

<script>
import HeadClone from "@/components/headClone"
export default {
  name: 'Home',
  components: { HeadClone },
  data () {
    return {
      count: null,
      isLoading: false,
      //1-普通员工 2-技术骨干 3-使命中人
      active: 0, activeList: [
        { title: '优秀员工', img: require('@/assets/img/recruit1.png'),value: 0 },
        { title: '技术骨干',img: require('@/assets/img/recruit2.png'), value: 1 },
        { title: '使命中人',img: require('@/assets/img/recruit3.png'), value: 2 },
      ],
      list: [],
      banner: '',
      page: 1,
      activeArr: [],
      nextActiveArr: [],
      nextArr: false
    }
  },
  // watch:{
  //   active(v){
  //     this.$router.replace({query:{active:v}})
  //     this.getList()
  //     this.getBanner()
  //   }
  // },
  methods: {
    getBanner () {
      const data = {
        column_type: 4,
        cate_id: this.active == 0 ? 1 : this.active == 1 ? 2 : 3
      }
      this.ajax.post('api/getbanner', data).then(res => {
        this.banner = res.data.thumb
      })
    },
    onActiveChange (v, isTabBar = false) {
      if (v == 'undefined') {
        history.go(-1)
      } else {
        if (isTabBar == true) {
          this.activeArr.push(this.active)
          this.active = v
        } else {
          this.active = v
        }
        this.$router.replace({ query: { active: v } })
      }
      this.page = 1
      this.isLoading = false
      this.list = []
      this.getBanner()
      this.getList()
    },
    changeActive (active) {
      this.active = active;
      this.getList()
    },
    back () {
      if (this.activeArr.length == 0) {
        history.go(-1)
      } else {
        let v = null
        v = this.activeArr[this.activeArr.length - 1]
        this.nextActiveArr.push(this.active)
        this.onActiveChange(v, false)
        this.activeArr.splice(this.activeArr.length - 1, 1)
        this.nextArr = true
      }
    },
    next () {
      if (this.nextActiveArr.length == 0) {
        history.forward()
      } else {
        const v = this.nextActiveArr[this.nextActiveArr.length - 1]
        this.activeArr.push(this.active)
        this.onActiveChange(v, false)
        this.nextActiveArr.pop()
        if (this.nextActiveArr.length == 0) {
          this.nextArr = false
        }
      }
      // this.active = this.active<2?this.active+1:0;
      // this.getList()
    },
    // next(){
    //   this.active = this.active<2?this.active+1:0;
    //   this.getList()
    // },
    getKeyList (page) {
      this.imgStatus = 0
      this.getList(page)
    },
    getList (page) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      this.ajax.post("recruits/getlist", { cate_id: this.active + 1, page: this.page, keyword: this.keyword }).then(({ data, count }) => {
        this.list = list.concat(data);
        this.count = count;
      }).finally(() => {
        this.isLoading = false;
      })
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    }
  },
  created () {
    let { active } = this.$route.query;
    if (active) {
      active = Number(active);
      this.active = active;
    }
    if (history.state.forward) {
      this.nextArr = true
    }
    this.getBanner()
    this.getList();

  },
  mounted () {
  }
}
</script>

<style scoped>
.myflex {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.flex1 {
  flex: 1;
}
.maxwidth {
  display: inline-block;
  max-width: 90px;
  overflow: hidden;
}
.textwidth { 
  width: calc(100% - 88px);
}
.already {
  padding: 2px 13px;
  border-radius: 20px;
  background-color: #ddd;
  font-size: 12px;
  color: #fff;
  margin-left: 5px;
}
.banner {
  width: 100%;
  margin-bottom: 10px;
}
.thumb {
  display: block;
  width: 88px;
  height: 88px;
  margin-right: 5px;
  object-fit: contain;
}
.scroll{
  padding-bottom: 10vw;
}
</style>
